import {
    SET_ONBOARDING_ANIMATION
} from "../const"


export const setOnboardingAnimation = (value) => ({
    type: SET_ONBOARDING_ANIMATION,
    payload: {value}
})
